import { useState, useEffect } from 'react'
import { BarChart3, Rocket, Users as UsersIcon, Eye } from 'lucide-react'
import { Link } from 'react-router-dom'
import { getAppStats, getCreatorAppStats, type AppStats, type CreatorAppStats } from '../../lib/api'

export default function AppUsageStats({ appName }: { appName: string }) {
  const [stats, setStats] = useState<AppStats | null>(null)
  const [creatorStats, setCreatorStats] = useState<CreatorAppStats | null>(null)

  useEffect(() => {
    Promise.all([
      getAppStats(appName, '30d'),
      getCreatorAppStats(appName).catch(() => null),
    ]).then(([appStats, creator]) => {
      setStats(appStats)
      if (creator) setCreatorStats(creator)
    }).catch(() => {})
  }, [appName])

  if (!stats) return null

  return (
    <div className="p-6 rounded-xl border border-border bg-card">
      <h2 className="text-lg font-semibold mb-4 flex items-center gap-2">
        <BarChart3 className="w-5 h-5" />
        Usage Stats <span className="text-xs font-normal text-muted-foreground">(30d)</span>
      </h2>
      <div className="space-y-3">
        <div className="flex items-center justify-between">
          <span className="flex items-center gap-2 text-muted-foreground text-sm">
            <Rocket className="w-4 h-4" />
            Builds
          </span>
          <span className="font-medium">{stats.build_count}</span>
        </div>
        <div className="flex items-center justify-between">
          <span className="flex items-center gap-2 text-muted-foreground text-sm">
            <Rocket className="w-4 h-4" />
            Deploys
          </span>
          <span className="font-medium">{stats.deploy_count}</span>
        </div>
        <div className="flex items-center justify-between">
          <span className="flex items-center gap-2 text-muted-foreground text-sm">
            <UsersIcon className="w-4 h-4" />
            Shared With
          </span>
          <span className="font-medium">{stats.shared_with_count} users</span>
        </div>
        {creatorStats && (
          <>
            <div className="flex items-center justify-between">
              <span className="flex items-center gap-2 text-muted-foreground text-sm">
                <Eye className="w-4 h-4" />
                Visitors
              </span>
              <span className="font-medium">{creatorStats.visit_count_30d}</span>
            </div>
            <div className="flex items-center justify-between">
              <span className="flex items-center gap-2 text-muted-foreground text-sm">
                <Eye className="w-4 h-4" />
                Unique Visitors
              </span>
              <span className="font-medium">{creatorStats.unique_visitors_30d}</span>
            </div>
          </>
        )}
      </div>
      <Link to="/creator-dashboard" className="text-xs text-primary hover:underline mt-3 block">
        View all analytics &rarr;
      </Link>
    </div>
  )
}
